import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ArrowUp } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface SendMessageInputProps {
  isSending: boolean
  onSend: (message: string) => void
  disabled?: boolean
  handleClear?: () => void
  placeholder?: string
}

export const SendMessageInput = ({
  disabled = false,
  onSend,
  isSending,
  placeholder,
}: SendMessageInputProps) => {
  const [message, setMessage] = useState('')

  const handleSend = () => {
    onSend(message)
    setMessage('')
  }

  return (
    <Box className="h-fit w-full flex flex-row gap-2 border border-solid border-f1-border rounded-lg p-1">
      <input
        placeholder={placeholder || i18n.t('meetings.meeting.chat.write_message')}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && message.length > 0) {
            handleSend()
          }
        }}
        style={{
          width: '100%',
          padding: '0 0.5rem',
        }}
        disabled={disabled}
      />
      <F0Button
        label="send"
        onClick={handleSend}
        loading={isSending}
        size="md"
        hideLabel
        variant="default"
        icon={ArrowUp}
        disabled={disabled || message.length === 0 || isSending}
      />
    </Box>
  )
}
